module.exports = __webpack_public_path__ + "static/media/textlayer_font.a13055f8.jpg";